/**
 * utils/browser-storage.ts
 *
 * The browser's local or session storage, or null where there is none
 * (private modes and blocked site data make even reading `localStorage` throw).
 * Callers take it as a default and let tests inject their own.
 */
export function browserStorage(kind: 'localStorage' | 'sessionStorage' = 'localStorage'): Storage | null {
  try {
    return globalThis[kind] ?? null;
  } catch {
    return null;
  }
}
